import React, { useEffect, useState, useRef } from 'react';
import { API_URLS } from '../config/api';

const ReferencesSlider = () => {
  const [references, setReferences] = useState([]);
  const [offset, setOffset] = useState(0);
  const trackRef = useRef(null);

  useEffect(() => {
    fetchReferences();
  }, []);

  const fetchReferences = async () => {
    try {
      const response = await fetch(`${API_URLS.REFERENCES}`);
      if (!response.ok) return;
      const data = await response.json();
      setReferences(data.filter(ref => ref.is_active === 1));
    } catch (error) {
      console.error('Error fetching references:', error);
    }
  };

  // Sonsuz, takılmasız kaydırma animasyonu
  useEffect(() => {
    if (!trackRef.current) return;

    let animationFrameId;
    let lastTime = null;

    // px/s cinsinden hız
    const baseSpeed = 40;

    const step = (timestamp) => {
      if (lastTime === null) {
        lastTime = timestamp;
        animationFrameId = requestAnimationFrame(step);
        return;
      }

      const deltaSeconds = (timestamp - lastTime) / 1000;
      lastTime = timestamp;

      setOffset((prev) => {
        const track = trackRef.current;
        if (!track) return prev;

        const totalWidth = track.scrollWidth || 0;
        const halfWidth = totalWidth / 2;
        if (halfWidth === 0) return prev;

        let next = prev - baseSpeed * deltaSeconds;

        // Yarım genişliği geçtiğinde başa sar ama fark kadar kaydır
        if (Math.abs(next) >= halfWidth) {
          next += halfWidth;
        }

        return next;
      });

      animationFrameId = requestAnimationFrame(step);
    };

    // Referanslar yüklendiğinde baştan başlat
    setOffset(0);
    animationFrameId = requestAnimationFrame(step);

    return () => {
      if (animationFrameId) {
        cancelAnimationFrame(animationFrameId);
      }
    };
  }, [references.length]);

  if (references.length === 0) {
    return null;
  }

  // Referansları iki kez tekrarla (sonsuz döngü için)
  const duplicatedReferences = [...references, ...references];

  return (
    <div className="w-full py-12 overflow-hidden">
      {/* Infinite Scroll Slider */}
      <div className="relative">
        {/* Gradient Overlays */}
        <div className="absolute left-0 top-0 bottom-0 w-16 md:w-32 bg-gradient-to-r from-white to-transparent z-10 pointer-events-none"></div>
        <div className="absolute right-0 top-0 bottom-0 w-16 md:w-32 bg-gradient-to-l from-white to-transparent z-10 pointer-events-none"></div>

        {/* Slider Track */}
        <div
          ref={trackRef}
          className="flex"
          style={{
            transform: `translateX(${offset}px)`,
            transition: 'none',
            willChange: 'transform',
          }}
        >
          {duplicatedReferences.map((reference, index) => (
            <div
              key={`${reference.id}-${index}`}
              className="flex-shrink-0 mx-3 md:mx-8 flex items-center justify-center"
              style={{ width: '120px', height: '80px' }}
            >
              <a
                href={reference.website}
                target="_blank"
                rel="noopener noreferrer"
                className="block w-full h-full flex items-center justify-center p-2 md:p-4 
                         transition-all duration-300 transform hover:scale-105"
              >
                <img
                  src={reference.logo}
                  alt={reference.name}
                  className="max-w-full max-h-full object-contain grayscale hover:grayscale-0 transition-all duration-300"
                  loading="lazy"
                  onError={(e) => {
                    e.target.onerror = null;
                    e.target.src = 'data:image/svg+xml,%3Csvg xmlns="http://www.w3.org/2000/svg" width="120" height="80"%3E%3Crect width="120" height="80" fill="%23f3f4f6"/%3E%3Ctext x="50%25" y="50%25" dominant-baseline="middle" text-anchor="middle" font-family="Arial" font-size="12" fill="%236b7280"%3E' + reference.name + '%3C/text%3E%3C/svg%3E';
                  }}
                />
              </a>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ReferencesSlider;

